import { fetchApi } from './api';

export const getTestAccounts = async (role) => {
  const query = role ? `?role=${role}` : '';
  return fetchApi(`/test-accounts${query}`, { method: 'GET' });
};

export const createTestAccount = async (data) => {
  return fetchApi('/test-accounts', {
    method: 'POST',
    body: data,
  });
};

export const updateTestAccount = async (id, data) => {
  return fetchApi(`/test-accounts/${id}`, {
    method: 'PUT',
    body: data,
  });
};

export const deleteTestAccount = async (id) => {
  return fetchApi(`/test-accounts/${id}`, {
    method: 'DELETE',
  });
};

